import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/core/components/base/base.component';
import { ToasterTypes } from 'src/app/core/enum/toaster-type.enum';
import { InvoiceService } from 'src/app/data/service/invoice.service';
import { OrganizationService } from 'src/app/data/service/organization.service';
import { SuppliersService } from 'src/app/data/service/suppliers.service';
import { ToasterMessageService } from 'src/app/shared/toaster-message/toaster-message.service';
import { ConfirmationDialogService } from '../../../../shared/confirmation-dialog/confirmation-dialog.service';
import { InvoiceActivity } from '../../models/activity/activity';
import { UserService } from 'src/app/data/service/user.service';
import { NotesComponent } from '../notes/notes.component';
import {
  ModalDirective,
  BsModalService,
  BsModalRef,
} from 'ngx-bootstrap/modal';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { catchError, debounceTime, switchMap, take, tap } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { RecognizedInvoiceService } from '../../services/recognized-invoice.service';
import {
  InvoiceUnReconcileShort,
  InvoiceUnReconciledAdd,
} from '../../models/invoice/invoice-short';
import { CreatedInvoiceWithLines } from '../../models/invoice/created-invoice-with-lines';
import { CreditNoteDTO } from '../../models/credit-note/credit-note';
import { BankTransactionDTO } from '../../models/expense/bank-transactions';
import { Subscription } from 'rxjs';
import { AccountingIntegration } from 'src/app/data/enums/accounting-integration';
import { Invoice } from '../../models/invoice/invoice';
import { PaymentAccount } from '../../models/account/payment-account';
import { Pannels } from '../../enums/sidebar-pannels';
import { NewSupplier } from '../../models/supplier/new-supplier';
import { SupplierShort } from '../../models/supplier/supplier-short';
import { CurrencyCode } from '../../enums/currency-code';
import { SupplierWithAlias } from '../../models/supplier/supplier-with-alias';
import { BankAccount } from '../../models/account/bank-account';
import { BankAccountService } from 'src/app/data/service/bank-account.service';
import { environment } from 'src/environments/environment';
import { tryGetObjectByProperty } from 'src/app/core/util/get-object-by-property';
import * as $ from 'jquery';
import { Guid } from 'guid-typescript';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TaxBasis } from '../../enums/taxBasis';
import { BillsToPayInvoiceDetailsRequest } from '../../models/invoice/bills-to-pay-invoice-details-request';
import { CustomModalComponent } from '../../../../shared/components/custom-modal/custom-modal.component';
import { ExpenseModalComponent } from '../../../../shared/components/expense-modal/expense-modal.component';
import { TaxRate } from '../../models/taxRate';
import { TransactionCodingService } from 'src/app/shared/components/transactions-table/transaction-coding.service';
import { SuggestedCodingService } from 'src/app/data/service/suggested-coding.service';
import {
  ManualCodingPayload,
  ManualCodingTransaction,
  AiCodingSuggestion
} from 'src/app/shared/components/manual-coding-modal/manual-coding-modal.component';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
})
export class ActivityComponent extends BaseComponent implements OnInit, AfterViewInit {
  @Output() moveBack = new EventEmitter<void>();
  @Output() deleteTrans = new EventEmitter<string>();
  @Output() assignTransa = new EventEmitter<object>();
  @Output() transNotes = new EventEmitter<object>();
  @Output() refreshDataOnMatch = new EventEmitter<object>();
  @Output() refreshDataOnUnMatch = new EventEmitter<object>();
  @Input() supplierName: string = '';
  @Input() invoiceId: string = null;
  @Input() supplierId: string = null;
  @Input() isInvoiceMode: boolean = true;
  @Input() invoiceColorNumber: number = 1;
  @Input() isBankTransMode: boolean = false;
  /**
   * Bills-to-Pay hosts embed this form in a stacked side-panel with a sticky
   * "Create Payment" footer, so the activity panel must leave room for it
   * (otherwise the notes composer drops below the fold and the body scrolls).
   */
  @Input() billsToPayMode: boolean = false;
  @Input() bankTransArr: any = [];
  /**
   * Bank-transaction mode: no matching or coding from the panel -- a report that has gone for
   * approval is not the submitter's to change. The rows still open, to be looked at.
   */
  @Input() codingDisabled: boolean = false;
  @Input() roleId: string = '';
  @Input() reportStatus: string = '';
  /** Opened from a note, so the conversation leads rather than the timeline. */
  @Input() openNotesFirst: boolean = false;
  currentPannel: Pannels = Pannels.DetailsTab;
  noteType: string = '';
  recordId: string = '';
  showToolTipDelay: number = 400;
  activities = [] as InvoiceActivity[];
  isSpinnerShown: boolean = false;
  isActivityExpanded: boolean = true;
  isNoteExpanded: boolean = true;
  organizationId: string = null;
  usersList: any[] = [];
  unreconciledData: InvoiceUnReconcileShort[] = [];
  reconcileData: InvoiceUnReconcileShort;
  isMatchSelected: boolean = false;
  isFileUploadProcessing: boolean = false;
  IsQuickBook: boolean = false;
  IsNoAccounting: boolean = false;
  curIdx: number = 0;
  shownCategoriesInvoiceId: number = 1;
  subscriptions: Subscription[] = [];
  panels = Pannels;
  isoutlookEnv: boolean = environment.isOutlookEnv;
  isChromeEnv: boolean = environment.isChromeEnv;
  invoice: Invoice = new Invoice(
    this._organizationService.selectedOrganization
  );
  creditNote: CreditNoteDTO = new CreditNoteDTO(
    this._organizationService.selectedOrganization
  );
  bankTransation: BankTransactionDTO = new BankTransactionDTO(
    this._organizationService.selectedOrganization
  );
  // row ={
  //   rowCount:1,supplierName:'Demo Company (AU)',hexColorClass:"sup_img_box_1",shortCode:"JD",isDemo:false,contactStatus:true,invoiceNumber:'123456',accountName:"Donations",total:123,amountDue:234,date:new Date('2024-03-12'),submissionMethod:3
  // }
  invoiceLines: any = [];
  lineItemList = [];
  isStatusChg: boolean = false;
  noteMentions: any[] = [];
  bankAccountList: PaymentAccount[] = [];
  type: string = '';
  isManualPaperwork: boolean = false;
  isCodeManually: boolean;
  taxRates: TaxRate[] = [];
  manualCoding: { categoryId: string; categoryName: string; contactId: string; contactName: string; reference: string; taxRateId: string; taxRateName: string; notes: string } = {
    categoryId: null, categoryName: null, contactId: null, contactName: null, reference: null, taxRateId: null, taxRateName: null, notes: null
  };
  isNewSupplierLoaded: boolean = false;
  selectedSupplierName: string;
  isNewSupplier: boolean = false;
  newSupplier: NewSupplier = new NewSupplier(
    this._organizationService.selectedOrganization
  );
  creatingNewSupplier: boolean = false;
  isCreateSupplierItemShown: boolean = false;
  suppliers: SupplierShort[] = [];
  currentSupplier: SupplierWithAlias = new SupplierWithAlias();
  bankAccount: BankAccount = new BankAccount(
    this._organizationService.selectedOrganization
  );
  defaultCurrency: CurrencyCode;
  account: PaymentAccount = new PaymentAccount();
  accounts: PaymentAccount[] = [];
  /** Code Manually's account list: active accounts only. */
  manualAccounts: PaymentAccount[] = [];
  supplierSearchList: SupplierShort[] = [];
  isFormValidated: boolean = false;
  isManualSaved: boolean = false;
  addDocumentForm: FormGroup;
  reconciledDataAdd: InvoiceUnReconciledAdd;
  selectedSupplierId: string;
  organizationTaxRateId: string;
  orgTaxBasis: TaxBasis = TaxBasis.DefaultRate;
  description: string = '';
  isSaving: boolean = false;
  showInvoiceFormPanel: boolean = false;
  invoiceEditable: boolean = false;
  showExpenseModal: boolean = false;
  showPublishValidation: boolean = false;

  @ViewChild('addDocumentModel') addDocumentModel: ModalDirective;
  get addDocumentFormControl() {
    return this.addDocumentForm.controls;
  }
  matchProcessing: boolean = false;
  @ViewChild('noteinput') noteinput: ElementRef;
  @ViewChild('commentModel') commentModel: ModalDirective;
  constructor(
    private readonly _invoiceService: InvoiceService,
    private readonly _toasterMessageService: ToasterMessageService,
    private readonly _organizationService: OrganizationService,
    private readonly _supplierService: SuppliersService,
    private _userService: UserService,
    private confirmationDialogService: ConfirmationDialogService,
    private _recognizedInvoiceService: RecognizedInvoiceService,
    private _bankAccountService: BankAccountService,
    private formBuilder: FormBuilder,
    private router: Router,
    private bsModalService: BsModalService,
    private _codingService: TransactionCodingService,
    private _suggestedCoding: SuggestedCodingService
  ) {
    super();
  }

  // ── Bank-transaction panel: coding without a match ───────────

  panelCodingBusy = false;
  private panelCodingCache: { key: string; transactions: ManualCodingTransaction[]; suggestion: AiCodingSuggestion | null } =
    { key: '', transactions: [], suggestion: null };

  /** The transaction on screen, keyed so the inline form is rebuilt when the panel pages. */
  get panelCodingKey(): string {
    const row = this.activities && this.activities[this.curIdx];
    return row ? String(row['unreconciledReportId'] || '') : '';
  }

  /** Same array between checks while the transaction is the same, for the form's inputs. */
  get panelCodingTransactions(): ManualCodingTransaction[] {
    const key = this.panelCodingKey;
    if (this.panelCodingCache.key !== key) {
      const row = this.activities && this.activities[this.curIdx];
      // SD-1254: a row the Coding Assistant suggested coding for opens with it filled in, marked
      // as suggested, to check and code -- or to change and code by hand.
      const coded = row && row['agentCoding'];
      this.panelCodingCache = {
        key,
        transactions: row && key ? [{
          id: key,
          date: row['transactionDate'],
          description: row['description'],
          amount: row['amount'],
          accountName: row['accountName']
        }] : [],
        suggestion: SuggestedCodingService.formSuggestion(coded)
      };
    }
    return this.panelCodingCache.transactions;
  }

  /** The Coding Assistant's suggestion for the transaction on screen, unless suggestions are hidden. */
  get panelCodingSuggestion(): AiCodingSuggestion | null {
    // Read through panelCodingTransactions, which keeps the cache on the transaction on screen.
    return this._suggestedCoding.isVisible && this.panelCodingTransactions.length
      ? this.panelCodingCache.suggestion : null;
  }

  /** The size of the bank line, which is what a match has to account for. */
  get panelTransactionAmount(): number {
    const row = this.activities && this.activities[this.curIdx];
    return Math.abs(Number(row && row['amount']) || 0);
  }

  matchAmount(item: any): number {
    return Math.abs(Number(item && item.amountDue) || 0);
  }

  /** Rounded to cents, so 0.1 + 0.2 style float noise never reads as a difference. */
  matchDifference(item: any): number {
    return Math.round((this.panelTransactionAmount - this.matchAmount(item)) * 100) / 100;
  }

  /**
   * The open transaction is reconciled, but not through Synced -- nothing in Synced is matched
   * to it. Its coding lives in the accounting system, so the panel says so instead of offering
   * matches or coding it again.
   */
  get reconciledElsewhere(): boolean {
    // A ledger row here, not an InvoiceActivity: bank mode hands the panel the host's rows.
    const txn: any = this.isBankTransMode ? this.activities?.[this.curIdx] : null;
    const matched = !!txn?.relatedID && txn.relatedID !== '00000000-0000-0000-0000-000000000000';
    return !!txn?.isReconciled && !matched && this.invoiceLines.length == 0;
  }

  /** Where a transaction reconciled outside Synced was reconciled. */
  get accountingSystemName(): string {
    if (this.IsNoAccounting) { return ''; }
    return this.IsQuickBook ? 'QuickBooks' : 'Xero';
  }

  get visibleSuggestionCount(): number {
    return (this.unreconciledData || []).filter((item: any) => item && item.visible).length;
  }

  // ── Find other matches ────────────────────────────────────────────────────
  // The matcher only suggests documents of the same amount. This is the way to everything
  // else: a searchable list of the documents no transaction is matched to yet. Picking one
  // puts it in the suggestions above, selected, so it is confirmed exactly as a suggestion is
  // -- with the same amounts check, since a hand-picked match is the one likely to differ.

  findMatchOpen = false;
  findMatchQuery = '';
  findMatchRows: InvoiceUnReconcileShort[] = [];
  findMatchLoading = false;
  findMatchError = '';
  /** The server's cap; a full page means there may be more, so the list says to search. */
  readonly findMatchLimit = 200;
  /** Rows drawn at a time: the closest ten, then ten more on request. */
  readonly findMatchPageSize = 10;
  findMatchShown = 10;

  get findMatchVisibleRows(): InvoiceUnReconcileShort[] {
    return this.findMatchSorted.slice(0, this.findMatchShown);
  }

  // Sorting. The list arrives closest-in-amount first, which is its order until a heading
  // is clicked: once for ascending, again for descending, a third time back to closest.
  // It orders the rows that were loaded (the closest findMatchLimit), not the whole Inbox.
  findMatchSortKey: 'supplier' | 'date' | 'submitter' | 'amount' | null = null;
  findMatchSortDir: 'asc' | 'desc' = 'asc';
  private findMatchSorted: InvoiceUnReconcileShort[] = [];

  sortMatchesBy(key: 'supplier' | 'date' | 'submitter' | 'amount'): void {
    if (this.findMatchSortKey !== key) {
      this.findMatchSortKey = key;
      this.findMatchSortDir = 'asc';
    } else if (this.findMatchSortDir === 'asc') {
      this.findMatchSortDir = 'desc';
    } else {
      this.findMatchSortKey = null;
      this.findMatchSortDir = 'asc';
    }
    this.findMatchShown = this.findMatchPageSize;
    this.applyMatchSort();
  }

  matchSortState(key: string): 'ascending' | 'descending' | 'none' {
    if (this.findMatchSortKey !== key) { return 'none'; }
    return this.findMatchSortDir === 'asc' ? 'ascending' : 'descending';
  }

  private applyMatchSort(): void {
    const key = this.findMatchSortKey;
    if (!key) {
      this.findMatchSorted = this.findMatchRows;
      return;
    }

    const direction = this.findMatchSortDir === 'asc' ? 1 : -1;
    const text = (value: any) => String(value || '').toLowerCase();
    const valueOf = (row: any): string | number => {
      switch (key) {
        case 'supplier': return text(row.supplierName);
        case 'submitter': return text(row.submitterName);
        case 'date': return row.date ? new Date(row.date).getTime() || 0 : 0;
        default: return this.matchAmount(row);
      }
    };
    // Rows with nothing in the column go last either way, rather than leading an A-Z sort.
    const isBlank = (row: any) => key === 'supplier' ? !row.supplierName
      : key === 'submitter' ? !row.submitterName
      : key === 'date' ? !row.date : false;

    this.findMatchSorted = this.findMatchRows
      .map((row, index) => ({ row, index, value: valueOf(row), blank: isBlank(row) }))
      .sort((a, b) => {
        if (a.blank !== b.blank) { return a.blank ? 1 : -1; }
        if (a.value < b.value) { return -direction; }
        if (a.value > b.value) { return direction; }
        return a.index - b.index;
      })
      .map(entry => entry.row);
  }

  get findMatchHiddenCount(): number {
    return Math.max(0, this.findMatchRows.length - this.findMatchShown);
  }

  showMoreMatches(): void {
    this.findMatchShown += this.findMatchPageSize;
  }

  /** How a document's amount sits against the bank line: "Same amount", "1.01 under", "3.73 over". */
  matchDifferenceLabel(row: any): string {
    const difference = this.matchDifference(row);
    if (difference === 0) { return 'Same amount'; }
    const size = Math.abs(difference).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return difference > 0 ? `${size} under` : `${size} over`;
  }

  /** The hand-picked document, kept so a reload of the suggestions does not drop it. */
  private pickedMatch: InvoiceUnReconcileShort = null;
  private findMatchSearch$ = new Subject<string>();
  private findMatchSub: Subscription;

  /**
   * Find other matches is with super admins only for now (role 1); the endpoint refuses
   * everyone else as well. Read from the signed-in user rather than the roleId input, which
   * the Transactions screen does not pass.
   */
  get canFindOtherMatches(): boolean {
    const role = Number(this._userService.loggedUserDetails.value?.role ?? this.roleId);
    return role === 1 && !this.codingDisabled;
  }

  openFindMatches(): void {
    if (!this.canFindOtherMatches) { return; }

    if (!this.findMatchSub) {
      this.findMatchSub = this.findMatchSearch$.pipe(
        tap(() => { this.findMatchLoading = true; this.findMatchError = ''; }),
        debounceTime(250),
        switchMap(query => this._invoiceService
          .getUnmatchedExpenses(this._organizationService.selectedOrganization, query, this.panelTransactionAmount)
          .pipe(catchError(() => {
            this.findMatchError = 'The list could not be loaded. Try again.';
            return of(null);
          })))
      ).subscribe((rows: any[]) => {
        this.findMatchLoading = false;
        if (rows) {
          this.findMatchRows = rows.map(row => this.asMatchCandidate(row));
          this.findMatchShown = this.findMatchPageSize;
          this.applyMatchSort();
        }
      });
    }

    this.findMatchOpen = true;
    this.findMatchQuery = '';
    this.findMatchRows = [];
    this.findMatchSortKey = null;
    this.findMatchSortDir = 'asc';
    this.applyMatchSort();
    this.findMatchSearch$.next('');
    setTimeout(() => (document.getElementById('fm-search-input') as HTMLInputElement)?.focus());
  }

  ngOnDestroy(): void {
    this.findMatchSub?.unsubscribe();
    super.ngOnDestroy();
  }

  closeFindMatches(): void {
    this.findMatchOpen = false;
  }

  onFindMatchQuery(query: string): void {
    this.findMatchQuery = query;
    this.findMatchSearch$.next(query);
  }

  retryFindMatches(): void {
    this.findMatchSearch$.next(this.findMatchQuery);
  }

  /** Whether the row is already one of the suggestions on the panel. */
  isAlreadySuggested(row: InvoiceUnReconcileShort): boolean {
    return (this.unreconciledData || []).some((item: any) => item.visible && item.id == row.id);
  }

  pickOtherMatch(row: InvoiceUnReconcileShort): void {
    this.pickedMatch = row;
    this.unreconciledData = this.withPickedMatch(this.unreconciledData);
    this.changeSelectedMatch(false, row.id);
    this.findMatchOpen = false;
  }

  /** The suggestions with the hand-picked document first, once, and showing. */
  private withPickedMatch(suggestions: InvoiceUnReconcileShort[]): InvoiceUnReconcileShort[] {
    const list = suggestions || [];
    if (!this.pickedMatch) { return list; }

    const existing = list.find(item => item.id == this.pickedMatch.id);
    if (existing) {
      existing.visible = true;
      return list;
    }
    return [this.pickedMatch].concat(list);
  }

  /** A row of the list in the shape of a suggestion, tied to the transaction on the panel. */
  private asMatchCandidate(row: any): InvoiceUnReconcileShort {
    const words = String(row.supplierName || '').trim().split(/\s+/).filter(Boolean);
    return {
      ...row,
      unreconciledReportId: this.activities[this.curIdx]['unreconciledReportId'],
      shortCode: words.length ? words.slice(0, 3).map(w => w.charAt(0)).join('') : 'NA',
      visible: true,
      selected: false
    };
  }

  trackByMatchId(_index: number, row: InvoiceUnReconcileShort): any {
    return row.id;
  }

  /** Codes through the same service as the ledger's own dialog, then lets the host reload. */
  onPanelCoding(payload: ManualCodingPayload): void {
    if (this.panelCodingBusy || !payload?.transactionIds?.length) { return; }

    this.panelCodingBusy = true;
    this._codingService.code(this._organizationService.selectedOrganization, payload, [])
      .subscribe(outcome => {
        this.panelCodingBusy = false;
        if (outcome.succeeded > 0) {
          this.refreshDataOnMatch.emit({ coded: payload.transactionIds });
        }
      });
  }

  initialsOf(name: string): string {
    const words = (name || '').trim().split(/\s+/).filter(Boolean);
    if (!words.length) { return '–'; }
    return (words.length > 1 ? words[0][0] + words[1][0] : words[0].slice(0, 2)).toUpperCase();
  }
  @ViewChild(NotesComponent) notesComponent: NotesComponent;
  @HostListener('click', ['$event'])
  onClick(event): void {
    this.notesComponent?.hideEmoji(event);
  }

  @ViewChild('activityRoot') activityRoot: ElementRef<HTMLElement>;

  /**
   * A bill's Activity tab fills the panel from where it starts to the bottom of the window.
   * It was a fixed calc() for a header of a set height, so the notes composer was cut off
   * under the panel's edge whenever the header was taller, with an empty strip below it.
   */
  invoicePanelHeight = 'calc(100vh - 185px)';

  ngAfterViewInit(): void {
    // After the panel has laid out, so its header's real height is known.
    setTimeout(() => this.fitInvoicePanel());
  }

  @HostListener('window:resize')
  fitInvoicePanel(): void {
    const el = this.activityRoot?.nativeElement;
    if (!el || !this.isInvoiceMode || this.isBankTransMode) return;
    const top = el.getBoundingClientRect().top;
    this.invoicePanelHeight = Math.max(240, Math.floor(window.innerHeight - top)) + 'px';
  }
  ngOnInit(): void {
    this.isCodeManually = false;
    this.addDocumentForm = new FormGroup({
      supplierId: new FormControl(null, [Validators.required]),
      accountId: new FormControl(null, [Validators.required]),
      detail: new FormControl(null, [Validators.required]),
      reference: new FormControl(null, [Validators.required]),
      taxCode: new FormControl(null)
    });

    this.setIsQuickBookOrNot();
    this.GetBankAcoountDetails();
    if (this.isInvoiceMode) {
      this.isSpinnerShown = true;

      this._invoiceService
        .getInvoiceActivityById(
          this.invoiceId,
          this._organizationService.selectedOrganization
        )
        .pipe(this.untilThis)
        .subscribe(
          (data: InvoiceActivity[]) => {
            this.activities = this.activities.concat(data);
            let actors = [] as string[];
            this.activities?.forEach((element) => {
              if (actors?.length == 0) {
                actors.push(element.actor);
              } else if (!actors.includes(element.actor)) {
                actors.push(element.actor);
              }
              element.visible = false;
            });

            if (actors && actors.length > 0) {
              this.activities.forEach((element) => {
                element.colorNumber = actors.indexOf(element.actor) + 1;
              });
            }
            this.isSpinnerShown = false;
          },
          (e: Error) => {
            this.isSpinnerShown = false;
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
          }
        );
    } else if (this.isBankTransMode) {
      this.organizationId = this._organizationService.selectedOrganization;
      this.isSpinnerShown = true;
      this.activities = this.bankTransArr;
      this.invoiceId = this.activities[this.curIdx]['unreconciledReportId'];
      this.getOrganizationDefaultCurrency();
      this.getSelectedTaxRate();
      this.getAccounts();
      this.getSuppliers();
      this.getTaxRates();
      this.getRelatedData();
    } else {
      this.isSpinnerShown = true;
      this._supplierService
        .getSupplierActivityById(
          this._organizationService.selectedOrganization,
          this.supplierId
        )
        .pipe(this.untilThis)
        .subscribe(
          (data) => {
            this.activities = this.activities.concat(
              data.filter((a) => a.date != null)
            );
            this.isSpinnerShown = false;
          },
          (e: Error) => {
            this.isSpinnerShown = false;
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
          }
        );
    }

    this.setNoteType();
  }

  getOrganizationDefaultCurrency() {
    this._organizationService
      .getOrganizationDefaultCurrency(
        this._organizationService.selectedOrganization
      )
      .pipe(take(1))
      .subscribe(
        (response) => {
          this.defaultCurrency = response.currency;
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  getSelectedTaxRate() {
    this._organizationService
      .getOrganizationTaxRateId(this._organizationService.selectedOrganization)
      .pipe(this.untilThis)
      .subscribe(
        (response) => {
          if (
            (this.IsQuickBook || this.IsNoAccounting) &&
            response.taxBasis == TaxBasis.IgnoreTax
          ) {
            this.orgTaxBasis = response.taxBasis;
            this.organizationTaxRateId = '0';
          } else {
            this.organizationTaxRateId = response.taxRateId;
          }
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  setIsQuickBookOrNot() {
    this.subscriptions.push(
      this._organizationService.organizationList.subscribe((data) => {
        const org = data?.find(
          (o) =>
            o.organisationID === this._organizationService.selectedOrganization
        );
        this.IsQuickBook =
          org?.accountingIntegration === AccountingIntegration.QBO
            ? true
            : false;
        this.IsNoAccounting =
          org?.accountingIntegration === AccountingIntegration.None
            ? true
            : false;
      })
    );
  }
  onScroll(event: any) {
    if (document.querySelector('#activitydiv').scrollTop < 70) {
      // document.getElementsByClassName("transIcon")[0].style.top=20;
      const highlights = document.getElementsByClassName('transIcon');
      for (let i = 0; i < highlights.length; i++) {
        const element = highlights[i] as HTMLElement;
        element.style.top =
          16 - document.querySelector('#activitydiv').scrollTop + 'px';
      }
    }
  }

  getRelatedData() {
    this.isSpinnerShown = true;
    // Unmatched is '' from the report grid but null from the Transactions ledger, whose
    // DTO types it as Guid?. Testing only for '' sent "null" as the id, the endpoint's
    // new Guid() threw, and the panel sat on its spinner for good.
    // A hand-picked match belongs to the transaction it was picked for.
    this.pickedMatch = null;
    this.findMatchOpen = false;
    if (this.activities[this.curIdx]['relatedID']) {
      this.relatedID = this.activities[this.curIdx]['relatedID'];
      this.relatedName = this.activities[this.curIdx]['relatedName'];

      this._invoiceService
        .getRelatedData(
          this._organizationService.selectedOrganization,
          this.activities[this.curIdx]['relatedID']
        )
        .subscribe((data: any) => {
          this.invoiceLines = data || [];
          this.isFileUploadProcessing = false;
          this.prepareProcessedInvoices(this.invoiceLines);
          if (this.isBankTransMode) {
            this._invoiceService
              .getMatchData(
                this._organizationService.selectedOrganization,
                this.activities[this.curIdx]['unreconciledReportId']
              )
              .subscribe((data: any) => {
                this.unreconciledData = data || [];
                this.prepareProcessedInvoices(this.unreconciledData);
                this.isSpinnerShown = false;
              }, () => { this.onRelatedDataFailed(); });
          } else {
            this.isSpinnerShown = false;
          }
        }, () => { this.onRelatedDataFailed(); });
    } else if (this.isBankTransMode) {
      // Unmatched, which is the case suggestions exist for -- so this is where they have to
      // be fetched. The getMatchData call used to sit inside the branch above, reached only
      // once a transaction already had an invoice on it: the panel asked for suggestions
      // exactly when there was nothing left to suggest, and every unmatched transaction was
      // told "No suggested matches found" without anything ever being looked up.
      this.relatedID = null;
      this.relatedName = null;
      this.invoiceLines = [];

      this._invoiceService
        .getMatchData(
          this._organizationService.selectedOrganization,
          this.activities[this.curIdx]['unreconciledReportId']
        )
        .subscribe((data: any) => {
          this.unreconciledData = data || [];
          this.prepareProcessedInvoices(this.unreconciledData);
          this.isSpinnerShown = false;
        }, () => { this.onRelatedDataFailed(); });
    } else {
      this.isSpinnerShown = false;
    }
  }

  /** A failed load must end the spinner and say so, not leave "Data loading..." up forever. */
  private onRelatedDataFailed(): void {
    this.isSpinnerShown = false;
    this.isFileUploadProcessing = false;
    this._toasterMessageService.displayToasterState(
      ToasterTypes.Error, 'Error', 'We could not load the matched invoice for this transaction.');
  }

  private prepareProcessedInvoices(array: any) {
    let count = 1;
    array.forEach((element) => {
      let stringToSplit = element.supplierName;

      if (stringToSplit) {
        let x = stringToSplit.split(' ');
        if (x.length == 1) {
          element.shortCode = x[0].charAt(0);
        }
        if (x.length == 2) {
          element.shortCode = x[0].charAt(0) + x[1].charAt(0);
        }
        if (x.length > 2) {
          element.shortCode = x[0].charAt(0) + x[1].charAt(0) + x[2].charAt(0);
        }
        if (x.length == 0) {
          element.shortCode = 'NA';
        }
      }
      element.visible = true;
      if (array.length > 0 && array.length == 1 && !this.isMatchSelected) {
        element.selected = true;
        this.changeSelectedMatch(false, element.id);
      } else {
        element.selected = false;
      }
      element.rowCount = count;
      count = count + 1;
      if (count == 7) {
        count = 1;
      }
    });
  }

  changeTransaction(type: string) {
    if (type == 'prev' && this.curIdx == 0) {
      return;
    } else if (type == 'next' && this.curIdx == this.activities.length - 1) {
      return;
    }

    this.isNoteExpanded = false;
    this.recordId = '';
    this.isSpinnerShown = true;
    this.isCodeManually = false;
    this.manualCoding = { categoryId: null, categoryName: null, contactId: null, contactName: null, reference: null, taxRateId: null, taxRateName: null, notes: null };
    setTimeout(() => {
      if (type == 'prev') {
        this.curIdx = this.curIdx == 0 ? 0 : this.curIdx - 1;
        this.recordId = this.activities[this.curIdx]['unreconciledReportId'];
      } else if (type == 'next') {
        this.curIdx =
          this.curIdx == this.activities.length - 1
            ? this.curIdx
            : this.curIdx + 1;
        this.recordId = this.activities[this.curIdx]['unreconciledReportId'];
      }
      this.isNoteExpanded = true;
      this.getRelatedData();
    });
  }

setNoteType() {
    this.recordId = this.invoiceId;
    this.noteType = 'Invoice';
    if (this.router.url.toLowerCase().indexOf('suppliers') > 0) {
      this.noteType = 'Contact';
      this.recordId = this.supplierId;
    }
    if (this.isBankTransMode) {
      this.noteType = 'unmatched';
      //this.recordId='15e3f792-64ba-4b10-96a7-288651214740';
    }
  }
  moveBackClick() {
    this.moveBack.emit();
  }

  datePipe: DatePipe = new DatePipe(this.getNavigatorLanguage());
  dateFormat: string;
  getFormattedDate(date: Date) {
    this.dateFormat = this._organizationService.selectedOrganizationDateFormat;
    this.dateFormat = this.dateFormat == "en-US" ? 'MM/dd/yy' : 'dd/MM/yy';
    var createdDate = this.datePipe.transform(
      date + 'Z',
      this.dateFormat ? this.dateFormat : 'dd/MM/yy',
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      this.getNavigatorLanguage()
    );
    var todaydate = new Date();
    var currentDate = this.datePipe.transform(todaydate, this.dateFormat);
    if (createdDate == currentDate) {
      return (
        'Today at ' +
        this.datePipe.transform(
          date + 'Z',
          'h:mm a',
          Intl.DateTimeFormat().resolvedOptions().timeZone,
          this.getNavigatorLanguage()
        )
      );
    } else {
      return (
        createdDate +
        ' at ' +
        this.datePipe.transform(
          date + 'Z',
          'h:mm a',
          Intl.DateTimeFormat().resolvedOptions().timeZone,
          this.getNavigatorLanguage()
        )
      );
    }
  }

  getNavigatorLanguage() {
    if (navigator.languages && navigator.languages.length) {
      return navigator.languages[0];
    } else {
      return 'en-US';
    }
  }

  removeTrans() {
    this.confirmationDialogService
      .confirm(
        'Confirm',
        'Do you want to delete this transaction?',
        'Yes',
        'No',
        ''
      )
      .then((confirm) => {
        if (confirm) {
          let data = { Action: 'removetrans' };
          this.saveTransactionStatus(data);
        } else {
          // this.DeleteSavedReport();
        }
      })
      .catch(() =>
        console.log(
          'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
        )
      );
  }
  saveTransactionStatus(data) {
    (data.AssignedBy = sessionStorage.Id),
      (data.UnreconciledReportId =
        this.activities[this.curIdx]['unreconciledReportId']),
      this._organizationService
        .saveTransactionStatus(data)
        .subscribe((result: any) => {
          if (result.status == 1) {
            if (data.Action == 'removetrans') {
              this.deleteTrans.emit(
                this.activities[this.curIdx]['unreconciledReportId']
              );
            }
            this.activities.splice(this.curIdx);
            this.curIdx =
              this.activities.length > this.curIdx || this.curIdx == 0
                ? this.curIdx
                : this.curIdx - 1;
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Success,
              'Success',
              result.Message
            );
          } else {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              result.Message
            );
          }
        });
  }
  assignTrans(obj: any) {
    this.assignTransa.emit(obj);
  }
  transNote(obj: any) {
    this.transNotes.emit(obj);
  }

  fileObj: any;
  uploadFile(file: any) {
    this.fileObj = file;
    this.activities[this.curIdx]['relatedID'] = file.id;
    this.activities[this.curIdx]['relatedName'] = file.name;
  }

  added(event: Event) {
    // this.loading = true;
    const [uploadedFile] = Array.from(
      (event.target as HTMLInputElement).files as FileList
    );

    let fileObj = { name: uploadedFile.name, file: uploadedFile };
    this.relatedName = fileObj.file.name;
    this.fileObj = fileObj;
    this.relatedID = null;
    this.isFileUploadProcessing = true;
    this.sendFile();
  }
  relatedID: string = null;
  relatedName: string = 'Test';
  uploadedFile: any;
  isFileProcessing: boolean = false;
  dropped(uploadedFiles: NgxFileDropEntry[]) {
    const fileEntry = uploadedFiles[0].fileEntry.isFile
      ? (uploadedFiles[0].fileEntry as FileSystemFileEntry)
      : null;
    let fileObj: any;
    fileEntry?.file((files: File) => {
      fileObj = { name: files.name, file: files };
      this.fileObj = fileObj;
      this.relatedName = fileObj.file.name;
      this.isFileUploadProcessing = true;
      this.relatedID = null;
      this.sendFile();
    });
  }

  async sendFile() {
    this.isFileProcessing = true;
    this.isFileUploadProcessing = true;
    // setTimeout(() => {
    //   this.isFileProcessing=false;
    // }, 5000);
    await this._invoiceService.uploadInvoice({
      organisationId: this._organizationService.selectedOrganization,
      invoice: this.fileObj.file,
      recordId: this.recordId,
      isBankTransMode: this.isBankTransMode,
    });

    this._recognizedInvoiceService.invoiceState$.pipe(take(1)).subscribe(
      (invoice: any) => {
        this.relatedID = invoice.id;
        this.relatedName = this.fileObj.file.name;
        this.uploadFile({ name: this.fileObj.file.name, id: invoice.id });
        this.isFileUploadProcessing = false;
        var model = {
          unreconciledReportIds: this.invoiceId,
          invoiceId: this.relatedID,
          organizationId: this._organizationService.selectedOrganization,
        };
        if (invoice.required_Fields) {
          this._invoiceService
            .updateSuggestedMatches(model)
            .pipe(take(1))
            .subscribe(() => {
              this.getRelatedData();
              this.refreshDataOnMatch.emit(
                new Object({ unRecId: this.invoiceId, relatedId: this.relatedID, invoiceUrl: invoice.url, accountName: invoice.accountName,
                  supplierName: invoice.supplierName, siDescription: invoice.siDescription
                 })
              );
              // this.activities[this.curIdx]['status'] = "Completed";
            });
        }
      },
      (e: Error) => {
        this._toasterMessageService.displayToasterState(
          ToasterTypes.Error,
          'Error',
          (e as any)?.error?.errorMessage || e.message
        );
        // this.isFileProcessing=false;
      }
    );
  }
  /**
   * Toggle selection on a suggested match.
   * - `event = false` → select this one (deselect any other; all remain visible
   *   so the user can switch by clicking a different card).
   * - `event = true`  → deselect this one.
   *
   * Visibility is *not* touched here — that's the dismiss (×) action via
   * `removeSuggestion`. Previously this method also hid all other rows on
   * select, which forced a "Cancel" affordance to bring them back; we drop
   * both behaviours together.
   */
  changeSelectedMatch(event, id) {
    if (!event) {
      this.reconcileData = new InvoiceUnReconcileShort();
      this.unreconciledData.forEach((_n, index) => {
        this.unreconciledData[index].selected = false;
      });
      const target = this.unreconciledData.find((x) => x.id == id);
      if (target) {
        target.selected = true;
        this.isMatchSelected = true;
        this.reconcileData = target;
      }
    } else {
      this.reconcileData = new InvoiceUnReconcileShort();
      this.unreconciledData.forEach((_n, index) => {
        this.unreconciledData[index].selected = false;
      });
      this.isMatchSelected = false;
    }
  }

  matchTransaction() {
    this.matchProcessing = true;
    var model = {
      unreconciledReportIds: this.reconcileData.unreconciledReportId,
      invoiceId: this.reconcileData.id,
      organizationId: this._organizationService.selectedOrganization,
    };
    this._invoiceService
      .updateSuggestedMatches(model)
      .pipe(take(1))
      .subscribe(
        () => {
          this.isMatchSelected = false;

          if (
            !this.reconcileData.isProcessed &&
            this.reconcileData.required_Fields
          ) {
            this._getInvoice(this.reconcileData.id);
          } else {
            this.getRelatedDataMatch();
          }
          this.refreshDataOnMatch.emit(
            new Object({
              unRecId: this.reconcileData.unreconciledReportId.toString(),
              relatedId: this.reconcileData.id,
              invoiceUrl: this.reconcileData.pdfUrl,
              accountName: this.reconcileData.accountName,
              supplierName: this.reconcileData.supplierName,
              siDescription: this.reconcileData.siDescription,
            })
          );
          // this.activities[this.curIdx]['status'] = "Completed";
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.ErrorInbox,
            '',
            (e as any)?.error?.errorMessage || `Error!`
          );
        }
      );
  }

  private _getInvoice(id) {
    if (id) {
      this._invoiceService
        .getInvoiceById(id)
        .pipe(take(1))
        .subscribe(
          (invoice: Invoice) => {
            this.invoice = invoice;
            this.handleInvoiceType();
            this.publishInvoice();
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
          }
        );
    }
  }

  private handleInvoiceType() {
    if (this.invoice.type !== null) {
      let invoiceType = this.invoice.type.toString();
      if (invoiceType == 'Credit Note' || invoiceType == 'ACCPAYCREDIT') {
        this.type = 'ACCPAYCREDIT';
      } else if (invoiceType == 'Supplier Invoice' || invoiceType == 'ACCPAY') {
        this.type = 'ACCPAY';
      } else if (invoiceType == 'Customer Invoice' || invoiceType == 'ACCREC') {
        this.type = 'ACCREC';
      } else if (invoiceType == 'Expense Claim' || invoiceType == 'EXPCLAIMS') {
        this.type = 'EXPCLAIMS';
      } else if (invoiceType == 'Receipt' || invoiceType == 'EXP') {
        this.type = 'EXP';
      }
    } else {
      this.type = 'ACCPAY';
    }
  }

  publishInvoice() {
    if (this.type == 'ACCPAYCREDIT') {
      this._invoiceService
        .publishCreditNote(this.getCreditNoteObject())
        .pipe(take(1))
        .subscribe(
          (data: any) => {
            this.getRelatedDataMatch();
          },
          (e: Error) => { }
        );
    } else if (this.type == 'EXP') {
      this.publishReceipt();
    } else {
      this._invoiceService
        .publishInvoice(this.getInvoiceObject())
        .pipe(take(1))
        .subscribe(
          (data: any) => {
            this.getRelatedDataMatch();
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
          }
        );
    }
  }

  getRelatedDataMatch() {
    this._invoiceService
      .getRelatedData(
        this._organizationService.selectedOrganization,
        this.reconcileData.id.toString()
      )
      .subscribe((data: any) => {
        this.invoiceLines = data;
        if (data.length > 0) {
          this.activities[this.curIdx]['relatedID'] = this.reconcileData.id;
        }
        this.prepareProcessedInvoices(this.invoiceLines);
        this.isMatchSelected = false;
        this.matchProcessing = false;
        this.isSpinnerShown = false;
      });
  }

  publishReceipt() {
    if (this.IsQuickBook) {
      this._invoiceService
        .publishReceiptQBO(this.getReceiptObjectQBO())
        .pipe(take(1))
        .subscribe(
          (data: any) => {
            this.getRelatedDataMatch();
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
          }
        );
    } else {
      this._invoiceService
        .publishReceipt(this.getReceiptObject())
        .pipe(take(1))
        .subscribe(
          (data: any) => {
            this.getRelatedDataMatch();
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
          }
        );
    }
  }

  getInvoiceObject(isSaving: boolean = false): CreatedInvoiceWithLines {
    let invoice = new CreatedInvoiceWithLines();
    invoice.classId = (this.invoice as any).classId || null;
    invoice.amountDue = this.invoice.amountDue ?? 0;
    invoice.currency = this.invoice.currency;
    invoice.date = this.invoice.date;
    invoice.dueDate = isSaving
      ? this.invoice.dueDate
      : !this.invoice.dueDate
        ? this.invoice.date
        : this.invoice.dueDate;
    invoice.supplierName = this.invoice.supplierName;
    invoice.supplierId = this.invoice.supplierId;
    (invoice.id = this.invoice.id.toString() ?? ''),
      (invoice.invoiceNumber = this.invoice.invoiceNumber);
    invoice.organisationId =
      this.invoice.organisationId ??
      this._organizationService.selectedOrganization;
    invoice.paymentStatus = this.invoice.paymentStatus;
    invoice.pdfUrl = this.invoice.pdfUrl;
    invoice.subTotal = this.invoice.subTotal ?? 0;
    invoice.totalTax = this.invoice.totalTax ?? 0;
    invoice.type = this.invoice.type;
    invoice.invoiceLines = this.invoice.invoiceLines;
    invoice.InvoiceOrCreditNote = this.invoice.type;
    invoice.paidBy = this.invoice.paidBy;
    invoice.expenseReportId = this.invoice.expenseReportId;
    invoice.expenseReportName = this.invoice.expenseReportName;
    invoice.paymentAccountNumber = this.invoice.paymentAccountNumber;
    invoice.paymentDate = this.invoice.paymentDate;
    invoice.unreconciledReportIds = this.invoiceId;
    if (invoice.invoiceLines?.length > 0) {
      for (let line of invoice.invoiceLines) {
        line.organisationId =
          this.invoice.organisationId ??
          this._organizationService.selectedOrganization;
        if (line.totalTax == null) {
          line.totalTax = 0;
        }
      }
    }

    return invoice;
  }

  getCreditNoteObject(isSaving: boolean = false): CreditNoteDTO {
    let creditNote = new CreditNoteDTO(
      this._organizationService.selectedOrganization
    );
    this.initCreditNoteLine();
    Object.keys(creditNote).reduce(
      (a, k) => ((a[k] = this.creditNote[k]), a),
      creditNote
    );
    creditNote.contact = {
      contactID: this.invoice.supplierId,
      name: this.invoice.supplierName,
      status: 'ACTIVE',
    };
    creditNote.invoiceID = this.invoice.id;
    creditNote.date = this.invoice.date;
    creditNote.subTotal = this.invoice.subTotal;
    creditNote.totalTax = this.invoice.totalTax;
    creditNote.total = this.invoice.amountDue;
    creditNote.lineItems = this.lineItemList;
    creditNote.PdfUrl = this.invoice.pdfUrl;
    creditNote.creditNoteID = this.invoice.id.toString();
    creditNote.InvoiceOrCreditNote = 'Credit Note';
    creditNote.currency = this.invoice.currency;
    creditNote.currencyCode = this.invoice.currency;
    creditNote.invoiceNumber = this.invoice.invoiceNumber;
    creditNote.unreconciledReportIds = this.invoiceId;
    return creditNote;
  }

  initCreditNoteLine() {
    if (this.invoice.invoiceLines.length > 0) {
      for (let i = 0; i < this.invoice.invoiceLines.length; i++) {
        var item = {
          description:
            this.invoice?.description === undefined ||
              this.invoice?.description === null ||
              this.invoice?.description === ''
              ? this.invoice.invoiceNumber
              : this.invoice?.description,
          trackingOptions: this.invoice.invoiceLines[i].trackingOptions,
          unitAmount:
            this.invoice?.amountDue -
            (this.invoice?.totalTax === null ? 0 : this.invoice?.totalTax),
          taxType: this.invoice.invoiceLines[i].taxId,
          taxAmount: this.invoice?.totalTax === null ? 0 : this.invoice?.totalTax,
          lineAmount: this.invoice.amountDue,
          accountCode: this.invoice.invoiceLines[i].accountId,
          quantity: 1,
        };

        this.lineItemList.push(item);
      }
    }
  }

  getReceiptObject(isSaving: boolean = false): BankTransactionDTO {
    let bankTransaction = new BankTransactionDTO(
      this._organizationService.selectedOrganization
    );
    Object.keys(bankTransaction).reduce(
      (a, k) => ((a[k] = this.bankTransation[k]), a),
      bankTransaction
    );

    let currentPaymentFrom: any = this.bankAccountList.find(
      (x) => x.accountID == this.activities[this.curIdx]['accountID']
    );
    bankTransaction.bankAccount = {
      accountID: currentPaymentFrom?.accountID ?? this.invoice?.accountID,
      name: currentPaymentFrom?.name ?? this.invoice?.accountName,
      type:
        currentPaymentFrom?.type == 'CREDITCARD'
          ? 'BANK'
          : currentPaymentFrom?.type,
      currencyCode: this.invoice.currency,
      bankAccountNumber: currentPaymentFrom?.bankAccountNumber,
    };
    bankTransaction.contact = {
      contactID: this.invoice.supplierId,
      name: this.invoice.supplierName,
      status: 'ACTIVE',
    };
    bankTransaction.date = this.invoice.date;
    bankTransaction.subTotal = this.invoice.subTotal;
    bankTransaction.totalTax = this.invoice.totalTax;
    bankTransaction.total = this.invoice.amountDue;
    bankTransaction.PdfUrl = this.invoice.pdfUrl;
    bankTransaction.invoiceId = this.invoice.id.toString();
    bankTransaction.InvoiceOrCreditNote = 'Receipt';
    bankTransaction.type = DocumentType['Receipt'];
    bankTransaction.currency = this.invoice.currency;
    bankTransaction.currencyCode = this.invoice.currency;
    bankTransaction.invoiceNumber = this.invoice.invoiceNumber;
    bankTransaction.paymentAccountNumber = this.invoice.paymentAccountNumber;
    bankTransaction.paymentStatus = this.invoice.paymentStatus;
    bankTransaction.lineItems = this.invoice.invoiceLines;
    bankTransaction.unreconciledReportIds = this.invoiceId;
    if (bankTransaction.lineItems?.length > 0) {
      for (let line of bankTransaction.lineItems) {
        line.accountName = '';
        line.organisationId =
          this.invoice.organisationId ??
          this._organizationService.selectedOrganization;
        if (line.totalTax == null) {
          line.totalTax = 0;
        }
      }
    }
    return bankTransaction;
  }

  getReceiptObjectQBO(isSaving: boolean = false): CreatedInvoiceWithLines {
    let invoice = new CreatedInvoiceWithLines();
    invoice.classId = (this.invoice as any).classId || null;
    invoice.amountDue = this.invoice.amountDue ?? 0;
    invoice.currency = this.invoice.currency;
    invoice.date = this.invoice.date;
    invoice.dueDate = isSaving
      ? this.invoice.dueDate
      : !this.invoice.dueDate
        ? this.invoice.date
        : this.invoice.dueDate;
    invoice.supplierName = this.invoice.supplierName;
    invoice.supplierId = this.invoice.supplierId;
    (invoice.id = this.invoice.id.toString() ?? ''),
      (invoice.invoiceNumber = this.invoice.invoiceNumber);
    invoice.organisationId =
      this.invoice.organisationId ??
      this._organizationService.selectedOrganization;
    invoice.paymentStatus = this.invoice.paymentStatus;
    invoice.pdfUrl = this.invoice.pdfUrl;
    invoice.subTotal = this.invoice.subTotal ?? 0;
    invoice.totalTax = this.invoice.totalTax ?? 0;
    invoice.type = this.invoice.type;
    invoice.invoiceLines = this.invoice.invoiceLines;
    invoice.InvoiceOrCreditNote = this.invoice.type;
    invoice.paidBy = this.invoice.paidBy;
    invoice.expenseReportId = this.invoice.expenseReportId;
    invoice.expenseReportName = this.invoice.expenseReportName;
    invoice.paymentAccountNumber = this.invoice.paymentAccountNumber;
    invoice.paymentDate = this.invoice.paymentDate;
    invoice.unreconciledReportIds = this.invoiceId;
    if (invoice.invoiceLines?.length > 0) {
      for (let line of invoice.invoiceLines) {
        line.organisationId =
          this.invoice.organisationId ??
          this._organizationService.selectedOrganization;
        if (line.totalTax == null) {
          line.totalTax = 0;
        }
      }
    }

    return invoice;
  }

  GetBankAcoountDetails() {
    this._organizationService
      .GetBankAccountDetails(
        'Organisation/GetBankAccountDetails',
        this._organizationService.selectedOrganization
      )
      .subscribe(
        (response: any) => {
          if (response.status == 0) {
            this.bankAccountList = response.data;
            if (this.bankAccountList?.length > 0) {
              this.bankAccountList.forEach((payAcc) => {
                payAcc.accountID = payAcc.accountID.toLowerCase();
              });
            }
          }
        },
        (err) => {
          this.bankAccountList = [];
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            err.message
          );
        }
      );
  }

  tabClick(tab: Pannels, isDefaultShow: boolean) {
    switch (tab) {
      case Pannels.DetailsTab:
        this.currentPannel = Pannels.DetailsTab;
        break;
      case Pannels.ActivityTab:
        this.showActivityPanel(isDefaultShow);
        break;
      default:
        this.currentPannel = Pannels.DetailsTab;
        break;
    }
  }

  showActivityPanel(isDefaultShow: boolean) {
    if (!isDefaultShow) {
      if (this.currentPannel == Pannels.ActivityTab) {
        this.currentPannel = Pannels.DetailsTab;
      } else {
        this.currentPannel = Pannels.ActivityTab;
      }
    }
  }

  addPaperwork() {
    const modalRef = this.bsModalService.show(CustomModalComponent, {
      class: 'modal-md',
      backdrop: 'static',
      keyboard: false,
      initialState: {
        title: 'Manual Expense',
        isManualPaperwork: true,
      },
    });

    modalRef.content.onClose.subscribe((result: any) => {
      if (result) {
        // Handle the form submission result here
        this.handleManualExpenseSubmission(result);
      }
    });
  }

  handleManualExpenseSubmission(formData: any) {
    if (formData) {
      // Handle the manual expense submission
      this.uploadManualInvoice();
    }
  }

  onSelectSupplier(event: SupplierShort) {
    this.isNewSupplierLoaded = true;
    if (event == undefined) {
      this.isNewSupplier = true;
      return;
    }
    this.isNewSupplier = false;
    this.isCreateSupplierItemShown = this.isNewSupplier;
    this.selectedSupplierName = event.name;
    this.getBankAccountDetailsBySupplierId(event.id, this.selectedSupplierName);
    this.updateCurrentSupplier();
    this.selectedSupplierId = event.id;
  }

  updateCurrentSupplier() {
    this.currentSupplier.id = !!this.invoice.supplierId
      ? this.invoice.supplierId
      : this.currentSupplier?.id;
    this.currentSupplier.name = this.suppliers.find(
      (s) => s.id === this.currentSupplier.id
    )?.name;
    this.currentSupplier.alias = !this.currentSupplier.alias
      ? this.invoice.supplierName
      : this.currentSupplier.alias;
    // this.hexColorClass = this.suppliers.find(s => s.id === this.currentSupplier.id)?.hexColorClass;
  }

  getBankAccountDetailsBySupplierId(supplierId: string, supplieName: string) {
    this._bankAccountService
      .getBankAccountBySupplierId(
        supplierId,
        this._organizationService.selectedOrganization
      )
      .pipe(take(1))
      .subscribe((data) => {
        if (!!data) {
          Object.keys(data).forEach(
            (k) =>
              (this.bankAccount[k] = !!data[k] ? data[k] : this.bankAccount[k])
          );
          this.bankAccount.contactId = supplierId;
          this.bankAccount.accountName = supplieName;
        } else {
        }
      });
  }

  handleSupplierName(event) {
    this.newSupplier.name = event;
    const matchedSupplier = this.suppliers?.filter(
      (s) => s.name == this.newSupplier.name
    );

    if (matchedSupplier?.length == 0 && event) {
      this.isCreateSupplierItemShown = true;
    } else if (!event) {
      this.handleSupplierBlur();
    } else {
      this.isCreateSupplierItemShown = false;
    }
  }

  handleSupplierBlur() {
    this.newSupplier.name = this.invoice.supplierName;
    this.isCreateSupplierItemShown = this.isNewSupplier;
  }

  createNewSupplier() {
    if (!this.creatingNewSupplier) {
      this.creatingNewSupplier = true;
      this.addNewSupplier(this.newSupplier, false);
    }
  }

  addNewSupplier(
    supplier: NewSupplier,
    setInvoiceSupplierName: boolean = true
  ) {
    supplier.bankAccountRequestModel = null;
    supplier.name = setInvoiceSupplierName
      ? this.invoice.supplierName
      : supplier.name;
    const name = JSON.parse(JSON.stringify(supplier.name));
    const newSupplier = JSON.parse(JSON.stringify(supplier));
    newSupplier.bsb = newSupplier.bsb?.replace('-', '');
    newSupplier.currency = this.defaultCurrency;
    newSupplier.IsSupplier = true;
    newSupplier.OrganizationId = this._organizationService.selectedOrganization;
    newSupplier.hexColorClass = 'sup_img_box_' + this.invoiceColorNumber;
    if (!newSupplier.defaultAccount.id) newSupplier.defaultAccount = null;
    this.creatingNewSupplier = true;
    this._supplierService
      .createSupplier(newSupplier)
      .pipe(this.untilThis)
      .subscribe((result) => {
        if (result?.supplierId == 'ConnectionLost') {
          if (this.IsQuickBook) {
            this._organizationService.getIntegrationCredentials('qbo').subscribe((res) => {
              if (res) {
                this._organizationService.refreshConnectionURL = res.revokeEndPoint;
                this._toasterMessageService.displayToasterState(
                  ToasterTypes.ErrorWithHtml,
                  null,
                  `QuickBooks connection lost. Please <a  class=\"toastr-link\" href=\"${this._organizationService.refreshConnectionURL}\">refresh</a> connection`
                );
              }
            });
          } else {
            this._organizationService.getIntegrationCredentials('xero').subscribe((res) => {
              if (res) {
                this._organizationService.refreshConnectionURL = res.revokeEndPoint;
                this._toasterMessageService.displayToasterState(
                  ToasterTypes.ErrorWithHtml,
                  null,
                  `Xero connection lost. Please <a  class=\"toastr-link\" href=\"${this._organizationService.refreshConnectionURL}\">refresh</a> connection`
                );
              }
            });
          }
        } else if (result?.message !== undefined) {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            null,
            result?.message
          );
          this.isNewSupplier = false;
          this.creatingNewSupplier = false;
          this.isCreateSupplierItemShown = false;
          const refField = document.getElementById('refField');
          refField.focus();
        } else {
          this.invoice.supplierId = result.supplierId;
          this.suppliers = [
            ...this.suppliers,
            {
              id: result.supplierId,
              name: supplier.name,
              defaultAccountCode: supplier?.defaultAccount.code,
            },
          ];
          this.isNewSupplier = false;
          this.creatingNewSupplier = false;
          this.isCreateSupplierItemShown = false;
          const refField = document.getElementById('refField');
          this.invoice.supplierName = name;
          refField.focus();
          this.account = supplier?.defaultAccount;
          if (supplier?.defaultAccount?.name == '') {
            supplier.defaultAccount.name = null;
          }
          this.getBankAccountDetailsBySupplierId(
            this.invoice.supplierId,
            this.invoice.supplierName
          );
          this.updateCurrentSupplier();
          this.updateSupplierStatus();
          $('.ng-dropdown-panel').remove();
          $('#ddlsupplier').removeClass('ng-select-opened');
        }
      });
  }

  updateSupplierStatus() {
    if (this.invoice.supplierName != null && this.invoice.supplierName != '') {
      const supplier = tryGetObjectByProperty(
        this.suppliers,
        'name',
        this.invoice.supplierName
      ) as SupplierShort;
      this.isNewSupplierLoaded = supplier ? true : false;
      this.isNewSupplier = !supplier && !this.invoice.supplierId ? true : false;
      this.isCreateSupplierItemShown = this.isNewSupplier;
      this.newSupplier.name = this.invoice.supplierName;
      this.invoice.supplierId = supplier?.id ?? this.invoice.supplierId;
    }
  }

  getAccounts() {
    this._bankAccountService
      .getPaymentAccounts(this._organizationService.selectedOrganization)
      .pipe(take(1))
      .subscribe((accounts: PaymentAccount[]) => {
        this.accounts = accounts;
        this.manualAccounts = (accounts || []).filter(a => a.isActive === true);
        !!this.invoice?.invoiceLines[0]?.accountId
          ? (this.account = this.accounts.find(
            (a) =>
              a.id.toLowerCase() ===
              this.invoice.invoiceLines[0].accountId.toLowerCase()
          ))
          : this.updateAccount();
      });
  }

  updateAccount() {
    const code = this.suppliers.find(
      (s) => s.id === this.invoice.supplierId
    )?.defaultAccountCode;
    let accountFind = this.accounts.find((x) => x.code == code);
    if (accountFind) {
      this.account = accountFind as PaymentAccount;
    } else {
      this.account = new PaymentAccount();
    }

    if (this.account?.name == '') {
      this.account.name = null;
    }
  }

  getSuppliers() {
    this._supplierService
      .getSuppliers(this._organizationService.selectedOrganization)
      .pipe(take(1))
      .subscribe((suppliers: SupplierShort[]) => {
        this.suppliers =
          suppliers?.sort((a, b) => a.name.localeCompare(b.name)) || [];
        this.suppliers.forEach((x) => (x.name = this.stripHTML(x.name)));
        this.supplierSearchList = this.suppliers;
      });
  }

  onSelectAccount(event: PaymentAccount) {
    if (event == undefined) {
      let data = {
        code: null,
        id: null,
        name: null,
        accountID: null,
      };
      this.account = data;
    }
    let data = {
      code: event.code,
      id: event.id,
      name: event.name,
      accountID: event.id,
    };
    this.account = data;
  }

  stripHTML(HTMLText: string): string {
    const reg = /<[^>]+>/gi;
    return HTMLText.replace(reg, '');
  }

  generateRandomNumber(): number {
    return Math.floor(100000 + Math.random() * 900000);
  }

  closeModel() {
    this.isManualPaperwork = false;
    this.addDocumentModel.hide();
  }

  addDocumentDetails() {
    this.updateCurrentMatchData();
    this.isManualSaved = true;
    this.addDocumentModel.hide();
  }

  updateCurrentMatchData() {
    let currentPaymentFrom: any = this.bankAccountList.find(
      (x) => x.accountID == this.activities[this.curIdx]['accountID']
    );
    this.reconciledDataAdd = {
      id: Guid.create().toString(),
      invoiceNumber: 'SYNC-' + this.generateRandomNumber(),
      supplierName: this.selectedSupplierName,
      date: this.activities[this.curIdx]['transactionDate'],
      amountDue: this.activities[this.curIdx]['amount'],
      accountName: this.account ? this.account.name : '',
      unRecDescription: this.activities[this.curIdx]['description'],
      unreconciledReportId:
        this.activities[this.curIdx]['unreconciledReportId'],
      type: 'ACCPAYCREDIT',
      supplierId: this.selectedSupplierId,
      accountId: this.account.id,
      currency: this.defaultCurrency,
      taxRateId: this.organizationTaxRateId,
      taxBasis: this.orgTaxBasis,
      required_Fields: true,
      organisationId: this.organizationId,
      bankAccount: {
        accountID: currentPaymentFrom?.accountID ?? this.invoice?.accountID,
        name: currentPaymentFrom?.name ?? this.invoice?.accountName,
        type:
          currentPaymentFrom?.type == 'CREDITCARD'
            ? 'BANK'
            : currentPaymentFrom?.type,
        currencyCode: this.defaultCurrency,
        bankAccountNumber: currentPaymentFrom?.bankAccountNumber,
      },
      isProcessed: false,
      description: this.description,
      isPaperwork: true,
    };
  }

  uploadManualInvoice() {
    this.isSaving = true;

    const invoiceArrived = this._recognizedInvoiceService.invoiceState$.pipe(take(1)).subscribe(
      (invoice: any) => {
        this.relatedID = invoice.id;
        // this.relatedName = this.fileObj.file.name;
        var model = {
          unreconciledReportIds: this.invoiceId,
          invoiceId: this.relatedID,
          organizationId: this._organizationService.selectedOrganization,
        };
        this._invoiceService
          .updateSuggestedMatches(model)
          .pipe(take(1))
          .subscribe(() => {
            this.isManualSaved = false;
            this.activities[this.curIdx]['relatedID'] = this.relatedID;
            this.getRelatedData();
            // this.activities[this.curIdx]['status'] = ;
            this.isManualPaperwork = false;
            this.refreshDataOnMatch.emit(
              new Object({ unRecId: this.invoiceId, 
                relatedId: this.relatedID,
                invoiceUrl: invoice.url, 
                accountName: this.reconciledDataAdd.accountName,
                supplierName: this.reconciledDataAdd.supplierName,
                siDescription: this.reconciledDataAdd.description,
              })
            );
            this.isSaving = false;
            this.isCodeManually = false;
          });
      },
      (e: Error) => {
        this._toasterMessageService.displayToasterState(
          ToasterTypes.Error,
          'Error',
          (e as any)?.error?.errorMessage || e.message
        );
      }
    );

    // A failed upload never reaches invoiceState$, so without this the panel sat on a blank
    // "Related" section for good. Put the coding form back, as filled in, to try again --
    // and drop the waiting subscription, or a later upload from anywhere else would be
    // linked to this transaction. (The service has already shown the error.)
    this._invoiceService.uploadInvoiceManually(this.reconciledDataAdd).subscribe(
      () => { },
      () => {
        invoiceArrived.unsubscribe();
        this.isSaving = false;
        this.isManualPaperwork = false;
        this.isCodeManually = true;
      }
    );
  }

  removeSuggestion(id) {
    this.isMatchSelected = false;

    // Immediately hide the card from the UI
    if (this.unreconciledData && this.unreconciledData.length) {
      const item = this.unreconciledData.find(i => i.id === id);
      if (item) {
        item.visible = false;
      }
    }

    // Fire API call in background – no spinner, no reload
    var model = {
      unreconciledReportIds: this.invoiceId,
      invoiceId: id,
      organizationId: this._organizationService.selectedOrganization,
    };
    this._invoiceService
      .updateInactiveSuggestedMatches(model)
      .pipe(take(1))
      .subscribe();
  }

  cancelUpload() {
    this.reconciledDataAdd = new InvoiceUnReconciledAdd();
    this.isManualPaperwork = false;
    this.isManualSaved = false;
    this.account = {
      id: this._organizationService.selectedOrganization,
      name: null,
      code: null,
      accountID: null,
    };
    this.addDocumentForm.reset();
  }

  closeInvoiceFormPanel() {
    this._invoiceService
      .getMatchData(
        this._organizationService.selectedOrganization,
        this.activities[this.curIdx]['unreconciledReportId']
      )
      .subscribe((data: any) => {
        this.unreconciledData = data || [];
        this.isMatchSelected = false;
        this.prepareProcessedInvoices(this.unreconciledData);
        // The document form was opened on a hand-picked match and closed without matching:
        // it is not one of the matcher's suggestions, so put it back, still selected.
        if (this.pickedMatch && !this.activities[this.curIdx]['relatedID']) {
          this.unreconciledData = this.withPickedMatch(this.unreconciledData);
          this.changeSelectedMatch(false, this.pickedMatch.id);
        }
        this.isSpinnerShown = false;
      });
    this.showInvoiceFormPanel = !this.showInvoiceFormPanel;
  }

  showInvoiceSideBar(invoiceId, isEditable) {
    this.showInvoiceFormPanel = true;
    this.invoiceEditable = isEditable;

    if (invoiceId) {
      this._invoiceService
        .getInvoiceById(invoiceId)
        .pipe(take(1))
        .subscribe(
          (invoice: Invoice) => {
            if (invoice.processed) {
              this.invoiceEditable = false;
              invoice.required_Fields = true;
            }
            this.reconcileData = new InvoiceUnReconcileShort();
            if (this.unreconciledData.findIndex((x) => x.id == invoice.id) > -1) {
              this.unreconciledData.find((x) => x.id == invoice.id).visible = true;
              this.isMatchSelected = true;
              this.reconcileData = this.unreconciledData.find((x) => x.id == invoice.id);
            }
            setTimeout(() => {
              this._recognizedInvoiceService.sendExistingInvoice(invoice);
            }, 300);
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
          }
        );
    }
  }

  /**
   * Unmatch undoes a reconciliation, and the coding it carried, in one click from a button
   * beside "View expense" -- so it asks first. Dismissing the dialog is a no.
   */
  confirmUnmatch(invoiceId: string, supplierName?: string): void {
    const what = supplierName ? `from ${supplierName}` : 'from its expense';
    this.confirmationDialogService.confirm(
      'Unmatch this transaction?',
      `This separates the transaction ${what} and puts it back in To reconcile, `
        + 'where it can be matched or coded again.',
      'Unmatch',
      'Keep match',
      null,
      'sm'
    ).then(
      confirmed => { if (confirmed) { this.unmatchTransaction(invoiceId); } },
      () => { /* dismissed */ }
    );
  }

  unmatchTransaction(invoiceId) {
    this.matchProcessing = true;
    var model = {
      unreconciledReportIds: this.invoiceId,
      invoiceId: invoiceId,
      organizationId: this._organizationService.selectedOrganization,
    };
    this._invoiceService
      .unMatchTransaction(model)
      .pipe(take(1))
      .subscribe(
        () => {
          this.matchProcessing = false;
          this.isMatchSelected = false;
          this.reconcileData.id = invoiceId;
          this.getRelatedData();
          this.refreshDataOnUnMatch.emit(
            new Object({
              unRecId: this.invoiceId,
              relatedId: invoiceId,
            })
          );
          // this.activities[this.curIdx]['status'] = "Completed";
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.ErrorInbox,
            '',
            `Error!`
          );
        }
      );
  }

  openManualExpenseModal(): void {
    const modalRef = this.bsModalService.show(CustomModalComponent, {
      initialState: {
        title: 'Add Manual Expense',
        isManualPaperwork: true,
      },
      class: 'modal-md',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.content?.onClose.subscribe((result: any) => {
      if (result) {
        this.selectedSupplierName = result.supplier?.name || '';
        this.account = result.account;
        this.description = result.description;
        this.isManualPaperwork = true;
        this.isManualSaved = true;
        this.updateCurrentMatchData();
      }
    });
  }

  openExpenseModal() {
    this.showExpenseModal = true;
  }

  getTaxRates() {
    this._organizationService
      .getTaxRates(this._organizationService.selectedOrganization)
      .pipe(take(1))
      .subscribe(
        (taxRates: TaxRate[]) => {
          this.taxRates = taxRates;
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error, 'Error', e.message
          );
        }
      );
  }

  switchToCodeManually() {
    this.isCodeManually = true;
    this.manualCoding = { categoryId: null, categoryName: null, contactId: null, contactName: null, reference: null, taxRateId: null, taxRateName: null, notes: null };
  }

  onSelectManualCategory(event: PaymentAccount) {
    if (event) {
      this.manualCoding.categoryId = event.id;
      this.manualCoding.categoryName = event.name;
    } else {
      this.manualCoding.categoryId = '';
      this.manualCoding.categoryName = '';
    }
  }

  onSelectManualContact(event: SupplierShort) {
    if (event) {
      this.manualCoding.contactId = event.id;
      this.manualCoding.contactName = event.name;
    } else {
      this.manualCoding.contactId = '';
      this.manualCoding.contactName = '';
    }
  }

  /**
   * ng-select's addTag for Code Manually's supplier picker: creates a supplier from what was
   * typed, and ng-select selects it once this resolves. On failure it says why and rejects,
   * which ng-select swallows, leaving nothing selected.
   *
   * Its own method rather than addNewSupplier above, which is wired to the invoice form
   * (this.invoice, #refField) that this panel does not show.
   */
  createManualSupplier = (term: string): Promise<SupplierShort> => {
    const name = (term || '').trim();
    if (!name || this.creatingNewSupplier) { return Promise.reject(); }

    const orgId = this._organizationService.selectedOrganization;
    const supplier: any = new NewSupplier(orgId, name);
    supplier.bankAccountRequestModel = null;
    supplier.defaultAccount = null;
    supplier.currency = this.defaultCurrency;
    supplier.IsSupplier = true;
    supplier.OrganizationId = orgId;
    supplier.hexColorClass = 'sup_img_box_' + this.invoiceColorNumber;

    this.creatingNewSupplier = true;

    return new Promise<SupplierShort>((resolve, reject) => {
      const fail = (message: string) => {
        this.creatingNewSupplier = false;
        this._toasterMessageService.displayToasterState(ToasterTypes.Error, null, message);
        reject();
      };

      this._supplierService.createSupplier(supplier).pipe(this.untilThis).subscribe(
        (result) => {
          if (result?.supplierId === 'ConnectionLost') {
            fail(`Your ${this.IsQuickBook ? 'QuickBooks' : 'Xero'} connection was lost, so the supplier could not be created. Reconnect it in Settings › Integrations.`);
            return;
          }
          // Same test as addNewSupplier: the endpoint only sets message when it refuses.
          if (!result?.supplierId || result?.message !== undefined) {
            fail(result?.message || 'We could not create that supplier.');
            return;
          }

          const created: SupplierShort = { id: result.supplierId, name };
          this.suppliers = [...this.suppliers, created].sort((a, b) => a.name.localeCompare(b.name));
          this.supplierSearchList = this.suppliers;
          this.creatingNewSupplier = false;
          this._toasterMessageService.displayToasterState(ToasterTypes.Success, 'Supplier created', name);
          resolve(created);
        },
        () => fail('We could not create that supplier.')
      );
    });
  };

  onSelectManualTaxRate(event: TaxRate) {
    if (event) {
      this.manualCoding.taxRateId = event.id;
      this.manualCoding.taxRateName = event.name;
    } else {
      this.manualCoding.taxRateId = '';
      this.manualCoding.taxRateName = '';
    }
  }

  cancelManualCoding() {
    this.isCodeManually = false;
    this.manualCoding = { categoryId: null, categoryName: null, contactId: null, contactName: null, reference: null, taxRateId: null, taxRateName: null, notes: null };
  }

  saveManualCoding() {
    this.selectedSupplierName = this.manualCoding.contactName || '';
    this.selectedSupplierId = this.manualCoding.contactId || null;
    this.description = this.manualCoding.reference || '';
    if (this.manualCoding.taxRateId) {
      this.organizationTaxRateId = this.manualCoding.taxRateId;
    }
    this.account = {
      id: this.manualCoding.categoryId,
      name: this.manualCoding.categoryName,
      code: '',
      accountID: this.manualCoding.categoryId,
    } as PaymentAccount;
    this.updateCurrentMatchData();
    if (this.manualCoding.notes) {
      this.reconciledDataAdd.unRecDescription = this.manualCoding.notes;
    }
    this.reconciledDataAdd.supplierId = this.selectedSupplierId;
    this.reconciledDataAdd.accountId = this.manualCoding.categoryId;
    this.reconciledDataAdd.accountName = this.manualCoding.categoryName;
    this.reconciledDataAdd.supplierName = this.manualCoding.contactName;

    this.isManualPaperwork = true;
    this.uploadManualInvoice();
  }

  handleExpenseModalClose(result?: any) {
    this.showExpenseModal = false;
    if (result) {
      this.reconciledDataAdd = result;
      this.reconciledDataAdd.unRecDescription =
        this.activities[this.curIdx]['description'];
      this.reconciledDataAdd.unreconciledReportId =
        this.activities[this.curIdx]['unreconciledReportId'];
      this.invoice.supplierId = this.reconciledDataAdd.supplierId;
      if ((result as any).classId) {
        (this.invoice as any).classId = (result as any).classId;
        if (this.invoice.invoiceLines) {
          this.invoice.invoiceLines.forEach((line) => {
            line.classId = (result as any).classId;
          });
        }
      }
      this.updateAccount();
      this.isManualSaved = true;
      this.isManualPaperwork = true;
      this.selectedSupplierName = this.reconciledDataAdd.supplierName;
    }
  }

  openTransaction() {
    this.showInvoiceSideBar(this.reconcileData.id, true);
  }

  closeSidebarOnMatchPublish() {
    this.refreshDataOnMatch.emit(
      new Object({
        unRecId: this.reconcileData.unreconciledReportId.toString(),
        relatedId: this.reconcileData.id,
        invoiceUrl: this.reconcileData.pdfUrl,
        accountName: this.reconcileData.accountName,
        supplierName: this.reconcileData.supplierName,
        siDescription: this.reconcileData.siDescription,
      })
    );
  }
}
